export enum ContentTypes {
  VIMEO,
  YOUTUBE,
  HUBSPOT_FORM = 3,
}
